import React from 'react';
import { Button, Typography, Stack, Paper } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import StandardView from '../components/core/StandardView';
import { getJob } from '../storage/MySearchesStore';
import SearchButton from '../components/search/SearchButton';

interface Props {}

const SearchNotFoundPage: React.FC<Props> = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const jobInfo = id ? getJob(id) : null;

  const handleSearchAgain = () => {
    console.log('Retrying search with job info:', jobInfo);
    if (jobInfo?.searchCriteria) {
      // Navigate to a new search page or re-trigger the same query
      navigate(`/`);
    } else {
      navigate('/');
    }
  };

  return (
    <StandardView>
      <Paper
        elevation={8}
        sx={{
          p: 4,
          borderRadius: 3,
          maxWidth: 800,
          mx: 'auto',
          mt: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Typography variant="h4" fontWeight="bold" gutterBottom color="primary">
          Something went wrong
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          We were unable to retrieve information related to this job.
          This may be due to an expired search, a deletion, or an internal error.
          We currently retain search results for approximately <strong>4 weeks</strong>.
          To preserve your results permanently, please download them before that time.
        </Typography>

        {jobInfo ? (
          <>
            <Typography variant="body1" sx={{ mb: 2 }}>
              The original search terms are still stored in your browser.
              Would you like to start a new search using the same terms?
            </Typography>
            <SearchButton searchFormValidated={true} species={jobInfo.searchCriteria.species} gene={jobInfo.searchCriteria.gene} accessionNumber={jobInfo.searchCriteria.accessionNumber} sequence={jobInfo.searchCriteria.sequence}/>
          </>
        ) : (
          <>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Unfortunately, the search parameters for this job could not be found.
              Please create a new search to continue.
            </Typography>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleSearchAgain}
              sx={{ mt: 1 }}
            >
              Start New Search
            </Button>
          </>
        )}
      </Paper>
    </StandardView>
  );
};

export default SearchNotFoundPage;